__turbopack_context__.v({
  "currencySelector": "LanguageSelector-module-scss-module__zzmyua__currencySelector",
  "languageLink": "LanguageSelector-module-scss-module__zzmyua__languageLink",
  "languageSelector": "LanguageSelector-module-scss-module__zzmyua__languageSelector",
  "languageSelectorBox": "LanguageSelector-module-scss-module__zzmyua__languageSelectorBox",
  "menuLink": "LanguageSelector-module-scss-module__zzmyua__menuLink",
  "optionLink": "LanguageSelector-module-scss-module__zzmyua__optionLink",
  "optionLinkActive": "LanguageSelector-module-scss-module__zzmyua__optionLinkActive",
  "optionLinkContainer": "LanguageSelector-module-scss-module__zzmyua__optionLinkContainer",
  "optionLinkContainerActive": "LanguageSelector-module-scss-module__zzmyua__optionLinkContainerActive",
  "optionLinkContainerEven": "LanguageSelector-module-scss-module__zzmyua__optionLinkContainerEven",
  "optionLinkContainerOdd": "LanguageSelector-module-scss-module__zzmyua__optionLinkContainerOdd",
});
